import { render, staticRenderFns } from "./PantryListItem.vue?vue&type=template&id=5424210b&scoped=true&"
import script from "./PantryListItem.vue?vue&type=script&lang=ts&"
export * from "./PantryListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PantryListItem.vue?vue&type=style&index=0&id=5424210b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5424210b",
  null
  
)

export default component.exports